// GENERATED by scripts/build-icons.mjs from icons/circle-x.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const XCircle = createIcon('circle-x', [
  ['circle', { cx: "12", cy: "12", r: "10" }],
  ['path', { d: "m15 9-6 6" }],
  ['path', { d: "m9 9 6 6" }],
])
